import * as React from "react";
import CenterDiv from "./CenterDiv";
import styled from "styled-components";

interface IProps {
  timeout?: number;
  fullPageOverlay?: boolean;
  size?: string;
}

interface IState {
  show: boolean;
}

const LoaderDiv = styled.div`
  border: 3px solid hsla(353, 98.1%, 41.2%, 0.2);
  border-top-color: hsl(353, 98.1%, 41.2%);
  border-radius: 50%;
  width: ${props => props.style.width || "3em"};
  height: ${props => props.style.height || "3em"};
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const OverLayDiv = styled.div`
  top: 0;
  left: 0;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
`;

class Loader extends React.Component<IProps, IState> {
  state: Readonly<IState> = { show: false };

  timeout: number;

  componentDidMount() {
    const { timeout = 300 } = this.props;
    this.timeout = window.setTimeout(
      () => this.setState({ show: true }),
      timeout
    );
  }

  componentWillUnmount() {
    clearTimeout(this.timeout);
  }

  render() {
    const { show } = this.state;
    const { fullPageOverlay, size } = this.props;
    const Spinner = <LoaderDiv style={{ width: size, height: size }} />;
    if (!show) {
      return null;
    } else {
      return fullPageOverlay ? (
        <OverLayDiv>{Spinner}</OverLayDiv>
      ) : (
        <CenterDiv>{Spinner}</CenterDiv>
      );
    }
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./app/javascript/components/core/Loader.tsx